<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="25" height="21.875"><path d="M0 8.594l9.375 8.594h1.563V12.5h3.906a5.466 5.466 0 0 1 5.469 5.469 5.977 5.977 0 0 1-1.562 3.906S25 19.531 25 13.281a8.594 8.594 0 0 0-8.594-8.594h-5.468V0H9.375z"/></svg>
</template>

<script>
	export default {
		name: "Reply"
	}
</script>